import { render, staticRenderFns } from "./PointWithdraw.vue?vue&type=template&id=9aceb940&scoped=true&"
import script from "./PointWithdraw.vue?vue&type=script&lang=js&"
export * from "./PointWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aceb940",
  null
  
)

export default component.exports